import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { history } from '../../_helpers';
import { Form, Input, Button } from 'semantic-ui-react';
import { useCurrentUser } from '../../_services';
import { setToast } from '../../store/ToastManagement';

export const ForgotPassword = () => {
  const { forgotPassword } = useCurrentUser();

  const [userName, setUserName] = useState('');
  const [errored, setErrored] = useState('');

  const dispatch = useDispatch();
  const displayMessage = (title, message, success) =>
    dispatch(
      setToast({
        title: title,
        success: success,
        body: message
      })
    );

  const validate = userName => {
    if (!userName) return 'Email address required';
    return false;
  };

  const sendResetPasswordEmail = async () => {
    const error = validate(userName);
    if (error) {
      setErrored(error);
      return;
    }

    try {
      await forgotPassword(userName);
      displayMessage('Success', 'Password reset email sent', true);
      history.push(`/login`);
    } catch (error) {
      displayMessage(
        'Error',
        'That account does not exist. You may need to retry creating it',
        false
      );
      history.push(`/login`);
    }
  };

  const onBlur = () => {
    const error = validate(userName);
    setErrored(error);
  };

  return (
    <React.Fragment>
      <Form>
        <div>
          <Form.Field>
            <label>EMAIL</label>
            <Input
              error={!!errored}
              value={userName}
              width={6}
              icon="user"
              iconPosition="left"
              name="userName"
              onBlur={onBlur}
              onChange={(_, { value }) => {
                setUserName(value);
              }}
            />
          </Form.Field>
          {errored && (
            <React.Fragment>
              <label>{errored}</label>
              <br />
              <br />
            </React.Fragment>
          )}
        </div>
        <br />
        <br />
        <Button
          style={{
            width: '100%'
          }}
          color="olive"
          onClick={event => {
            event.preventDefault();
            sendResetPasswordEmail();
          }}
        >
          SEND PASSWORD RESET EMAIL
        </Button>
      </Form>
    </React.Fragment>
  );
};
